<div class="feature-restriction-select">
  <h4>Feature Management</h4>

  <div class="feature-option-row feature-option-header">
    <div class="feature-option-label">Feature</div>
    <div class="feature-option-description">Description</div>
    <div class="feature-option-toggle">Disable Feature</div>
  </div>
  <hr />
  <div *ngFor="let option of availableFeatures">
    <div class="feature-option-row">
      <div class="feature-option-label">{{ option.label }}</div>
      <div class="feature-option-description">
        Prevents {{ option.description }}
      </div>
      <div class="feature-option-toggle">
        <scaffold-toggle-slide
          status="info"
          (change)="updateSwitch('limit_' + option.value)"
          [(ngModel)]="this['limit_' + option.value]">
        </scaffold-toggle-slide>
      </div>
    </div>
  </div>
</div>
